import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styled, { css, keyframes, withTheme } from 'styled-components'
import { Button, getPaletteColor } from 'pcln-design-system'
import { get } from 'lodash'
import { Swap } from 'pcln-icons'

const pulse = keyframes`
    50% { transform: scale(1.2); }
`

const spin = keyframes`
    100% { transform: rotate(270deg); }
`

const animationPulse = css`
  ${pulse} ${(props) => props.theme.duration.slowest};
`

const animationSpin = css`
  ${spin} ${(props) => props.theme.duration.slowest};
`

const AnimatedButton = styled(Button)`
  background-color: ${getPaletteColor('primary.base')};
  height: 25px;
  &.animated {
    animation: ${animationPulse};
  }
  &:hover {
    background-color: ${getPaletteColor('primary.dark')};
  }
`

const AnimatedSwapIcon = styled(Swap)`
  transform: rotate(90deg);
  &.animated {
    animation: ${animationSpin};
  }
  &:focus {
    outline: none;
  }
`

const getAnimationDurationMs = (props) => {
  let animationDurationMs = 0
  if (get(props, 'theme.duration.slowest')) {
    const durationStr = get(props, 'theme.duration.slowest', '')
    animationDurationMs = Number(durationStr.match(/^(\d+)/)[0])
  }
  return animationDurationMs
}

class ArrowSpinButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonClassName: '',
      animationDurationMs: getAnimationDurationMs(props),
    }
    this.buttonClick = this.buttonClick.bind(this)
  }

  buttonClick() {
    this.props.onClick()
    this.setState({ buttonClassName: 'animated' }, () => {
      setTimeout(() => this.setState({ buttonClassName: '' }), this.state.animationDurationMs)
    })
  }

  render() {
    return (
      <AnimatedButton
        className={classnames(this.props.className, this.state.buttonClassName)}
        onClick={this.buttonClick}
        data-selenium={this.props.identifier}
        aria-label={this.props.description}
        width={'26px'}
        p={0}
        borderRadius={this.props.borderRadius}
      >
        <AnimatedSwapIcon
          color='text.lightest'
          titleId={this.props.identifier + 'svg-title'}
          title={this.props.description}
          desc={this.props.description}
          descId={this.props.identifier + 'svg-desc'}
          className={this.state.buttonClassName}
          data-testid={this.props.description}
          tabIndex={null}
        />
      </AnimatedButton>
    )
  }
}

ArrowSpinButton.defaultProps = {
  description: 'Switch Cities',
  identifier: 'SwitchCitiesButton',
  borderRadius: 'sm',
}

ArrowSpinButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  description: PropTypes.string,
  identifier: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.shape({
    duration: PropTypes.shape({
      slowest: PropTypes.string,
    }),
  }),
  borderRadius: PropTypes.string,
}

export default withTheme(ArrowSpinButton)
